import Container from "@/components/ContentContainer/Container";
import InnerContainer from "@/components/ContentContainer/InnerContainer";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import Skeleton from "@/components/Skeleton/Skeleton";
import StatusTag from "@/components/StatusTag/StatusTag";
import useTrackOnLoad from "@/hooks/useTrackPageview";
import { useParams } from "react-router-dom";
import { useGetGoodsAndServicesItem } from "../useGoodsAndServices";
import styles from "./GoodsAndServicesItemDetail.module.scss";
import GoodsAndServicesItemDetails from "./GoodsAndServicesItemDetails";
import GoodsAndServicesItemImpact from "./GoodsAndServicesItemImpact";
import GoodsAndServicesItemRelations from "./GoodsAndServicesItemRelations";
import GoodsAndServicesItemUnitConversion from "./GoodsAndServicesItemUnitConversion";

export default function GoodsAndServicesItemDetail() {
  useTrackOnLoad("Goods & Services Item Viewed");

  const { goodsAndServicesItemId: id } = useParams();
  const goodsAndServicesItemId = Number(id);

  const { data: goodsAndServicesItem, isLoading } = useGetGoodsAndServicesItem({
    goodsAndServicesItemId,
  });

  return (
    <div className={styles.GoodsAndServicesItemDetail}>
      <PageHeader
        title={goodsAndServicesItem?.name}
        loading={isLoading}
        right={
          <>
            {isLoading ? (
              <Skeleton style={{ width: "90px", height: "24px" }} />
            ) : (
              <StatusTag
                status={goodsAndServicesItem?.status || "error"}
                background="white"
              />
            )}
          </>
        }
      />
      <Container
        contentClassName={styles.container}
        padding={false}
      >
        <InnerContainer
          className={styles.left}
          padding={false}
        >
          <InnerContainer title="Details">
            <GoodsAndServicesItemDetails goodsAndServicesItemId={goodsAndServicesItemId} />
          </InnerContainer>
        </InnerContainer>
        <InnerContainer
          className={styles.right}
          borderLeft={true}
          padding={false}
        >
          <InnerContainer
            title="Impact"
            borderBottom={true}
          >
            <GoodsAndServicesItemImpact goodsAndServicesItemId={goodsAndServicesItemId} />
          </InnerContainer>
          <InnerContainer
            title="Unit conversion"
            borderBottom={true}
          >
            <GoodsAndServicesItemUnitConversion goodsAndServicesItemId={goodsAndServicesItemId} />
          </InnerContainer>
          <InnerContainer title="Relations">
            <GoodsAndServicesItemRelations goodsAndServicesItemId={goodsAndServicesItemId} />
          </InnerContainer>
        </InnerContainer>
      </Container>
    </div>
  );
}
